module.exports = __webpack_public_path__ + "img/dp158_02.e77fc584.jpg";